import React, { FC } from 'react';
import { HStack, Icon, Input, InputField, InputSlot, Pressable, Text } from '@gluestack-ui/themed';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { FontAwesome5 } from "@expo/vector-icons";
import { formatNumber } from "../../utils/general";

export const NumberElement: FC<IElementBaseProps> = (({ ...props }) => {
    const {
        itemsStore, element, statusStore,
        payload, setPayload, errorList, setErrorList
    } = initializeElement(props);
    const btnSizes: ("xs" | "sm" | "md" | "lg" | "xl")[] = ['xl', 'lg', 'md', 'sm', 'xs', 'xs'];
    let lstValuesCounter: string[] = [];
    if (element.templateData.btnCounter) {
        lstValuesCounter = (element.templateData.valuesCounter || "1").split(",");
    }
    const handleChange = (value: string | undefined) => {       
        value = (value ?? "").replace(",",".");    
        value =  (value && (!isNaN(Number(value)) || value == '-') ? value : "");
        let errorElement = itemsStore.getErrorElement(element, value);        
        let decimalIndexOf = value.toString().indexOf(".");
        if (value && decimalIndexOf > 0 && typeof element.templateData.maxDecimalsCount == "number") {
            let pos = element.templateData.maxDecimalsCount > 0 ? element.templateData.maxDecimalsCount + 1 : element.templateData.maxDecimalsCount;
            value = value.toString().substring(0, decimalIndexOf + pos);
        }
        setErrorList(errorElement.errorList);
        setPayload({ ...payload, value: value, valid:  errorElement.valid });
    }
    
    const handleKBToolbar = (val: string) => {   
        if (val != ""){
            let payload=itemsStore.getPayloadElement(element.id, props.parentId);    
            val = (payload.value || "").concat(val);
        }        
        handleChange(val)
    }
    const maskValue = ()=>{
        const {
            forceDecimals = false,
            maxDecimalsCount = 2,
            thousandSeparator = false
        } = element.templateData || {};
        return formatNumber(payload.value, 
            forceDecimals? maxDecimalsCount : null,
            thousandSeparator ? ",":""
        );
    }
    let sizeStyle = element.templateData.compactSize ?
        {
            fontSize: 12,
            lineHeight: 16,
            size: "sm" as const,
            paddingVertical: 2,
            inputHeight: 24,
        }
        :
        {
            fontSize: 16,
            lineHeight: 22,
            size: "md" as const,
            paddingVertical: 4,
            inputHeight: 32,
        }
        ;

        const bgColor = element.templateData.readOnly
            ? "transparent"
            : "#00000010";

    return <ElementBase errors={errorList} element={element} forReview={props.forReview} changedMe={payload.value}>
        {props.forReview || element.templateData.readOnly ?
            <Text style={{ color: (element.templateData.textColor ? element.templateData.textColor : "#000"), fontSize: sizeStyle.fontSize }} pl="$7">
                {maskValue()}
            </Text>
            :
            <HStack alignItems="center" justifyContent="flex-start">
                <Input
                    variant="unstyled"
                        size={sizeStyle.size}
                        isReadOnly={!!element.templateData.readOnly}
                        backgroundColor={bgColor}
                        borderWidth={0}
                        py="$0"
                        px="$0"
                        alignItems="center"
                        height={sizeStyle.inputHeight}
                        minWidth={70}
                        width="100%"
                >
                    <InputSlot pl="$1">
                        <HStack alignItems="center" space="xs">
                            {lstValuesCounter.map((valueStr: string, idx: number) => {
                                const value = parseFloat(valueStr);
                                return (
                                    <Pressable
                                        key={'btnMinus'.concat(idx.toString())}
                                        p="$1"
                                        onPress={() => {
                                            let newVal = parseFloat(payload.value ?? 0);
                                            newVal = isNaN(newVal) ? 0 : newVal;
                                            newVal -= value;
                                            if (element.templateData.minimum == undefined || element.templateData?.minimum <= newVal)
                                                handleChange(newVal.toString());
                                            else
                                                handleChange(element.templateData.minimum.toString());
                                        }}
                                    >
                                        <Icon
                                            as={FontAwesome5}
                                            name="minus-circle"
                                            size={btnSizes[idx] || "sm"}
                                            color="$red600"
                                        />
                                    </Pressable>
                                );
                            }).reverse()}
                            <Icon as={FontAwesome5} name="hashtag" size="2xs" fontSize={12} />
                        </HStack>
                    </InputSlot>

                    <InputField
                        keyboardType="numeric"
                        onFocus={() => statusStore.configKBToolbar({ type: 'numeric', fn: handleKBToolbar })}
                        onChangeText={handleChange}
                        color={element.templateData.textColor || "#000"}
                        placeholder={element.templateData.placeholder || ""}
                        placeholderTextColor="#8C8C8C"
                        value={payload.value?.toString() || ""}
                        style={{
                                fontSize: sizeStyle.fontSize,
                                lineHeight: sizeStyle.lineHeight,
                                paddingVertical: 0,
                                textAlignVertical: "center",
                                includeFontPadding: false,
                            }}
                        width="100%"
                        
                        paddingHorizontal="$0"
                        py="$0"
                        px="$0"
                        
                    />

                    <InputSlot pr="$1">
                        <HStack alignItems="center" space="xs">
                            {lstValuesCounter.map((valueStr: string, idx: number) => {
                                const value = parseFloat(valueStr);
                                return (
                                    <Pressable
                                        key={'btnPlus'.concat(idx.toString())}
                                        p="$1"
                                        onPress={() => {
                                            let newVal = parseFloat(payload.value ?? 0);
                                            newVal = isNaN(newVal) ? 0 : newVal;
                                            newVal += value;
                                            if (element.templateData.minimum == undefined || element.templateData.maximum == undefined || element.templateData.maximum >= newVal)
                                                handleChange(newVal.toString());
                                            else
                                                handleChange(element.templateData?.maximum.toString());
                                        }}
                                    >
                                        <Icon
                                            as={FontAwesome5}
                                            name="plus-circle"
                                            size={btnSizes[idx] || "sm"}
                                            color="$green600"
                                        />
                                    </Pressable>
                                );
                            })}
                        </HStack>
                    </InputSlot>
                </Input>
            </HStack>
        }
    </ElementBase>
});